/* eslint-env browser */


/**
 * Infinite Scroll using a "Load more" button
 * Used on all pages where there is a list of posts (homepage, tag index, etc).
 *
 * When the "Load more" button is clicked, the next page of posts
 * is fetched by following the the <link rel="next" href="..."> that is output
 * by {{ghost_head}}.
 *
 * The individual post items are extracted from the fetched pages by looking for
 * a wrapper element with the class "post-card". Any found elements are appended
 * to the element with the class "post-feed" in the currently viewed page.
 */

 (function (window, document) {
    var totalPages = 1;
    var currentPage = 1;
    var loading = false;

    // "Load more" button
    var loadMoreBtn = document.querySelector(".post-feed-load-more-btn");
    if (!loadMoreBtn) {
        return;
    }

    // next link element
    var nextElement = document.querySelector('link[rel=next]');
    if (!nextElement) {
        loadMoreBtn.remove();
        return;
    } 

    // post feed element
    var feedElement = document.querySelector(".post-feed, .js-post-feed");
    if (!feedElement) {
        loadMoreBtn.remove();
        return;
    }

    // Get total page count
    totalPages = Number(loadMoreBtn.getAttribute("data-total-pages"));

    // Add page counter for screen readers
    if (totalPages > 1) {
        var label = "Page 1 of " + totalPages;

        feedElement.insertAdjacentHTML(
            "afterbegin",
            "<span class='visually-hidden' role='separator'>" + label + "</span>"
        );
    }

    function onPageLoad() {
        if (this.status === 404) {
            loadMoreBtn.remove();
            return;
        }

        if (this.status >= 400) {
            return;
        }        

        currentPage++;

        // Add separator/page counter for screen readers
        var label = "Page " + currentPage + " of " + totalPages;
        var separator = document.createElement("span");
        separator.setAttribute("class", "visually-hidden");
        separator.setAttribute("role", "separator");
        separator.innerText = label;

        feedElement.appendChild(separator);

        // Append contents
        var first = null;
        var postElements = this.response.querySelectorAll(
            ".post-feed .post-card.post, .js-post-card"
        );

        var fragment = document.createDocumentFragment();

        postElements.forEach(function (item, index) {
            // document.importNode is important, without it the item's owner
            // document will be different which can break resizing of
            // `object-fit: cover` images in Safari
            var node = document.importNode(item, true);

            fragment.appendChild(node);

            if (index === 0) {
                first = node;
            }
        });

        // Remove tmp elements
        var tmpElements = feedElement.querySelectorAll('.post-card-tmp');
        tmpElements.forEach(function(item) {
            feedElement.removeChild(item);
        });

        // Add new posts
        feedElement.appendChild(fragment);

        // bring the focus back to the first element of the new page
        if (first) {
            setTimeout(() => {
                first.setAttribute("tabindex", -1);
                first.focus();
                first.blur();
                first.removeAttribute("tabindex");
            });
        }

        // sync status
        loading = false;
        loadMoreBtn.classList.toggle("loading");

        // set next link
        var resNextElement = this.response.querySelector('link[rel=next]');

        if (resNextElement) {
            nextElement.href = resNextElement.href;
            fixCount();
        } else {
            loadMoreBtn.remove();
        }
    }

    function onClick() {
        // return if already loading
        if (loading) {
            return;
        }

        loading = true;
        loadMoreBtn.classList.toggle("loading");

        var xhr = new window.XMLHttpRequest();
        xhr.responseType = "document";

        xhr.addEventListener("load", onPageLoad);

        xhr.open("GET", nextElement.href);
        xhr.send(null);
    }


    // Add one extra post in home page to fix last row when there is a large post & on desktop
    function fixCount() {
        var mq = window.matchMedia("(min-width: 1001px)"); // Desktop media query. Needs to be in sync with css
        var largePost = feedElement.querySelector(".post-card-large");

        if (loading 
            || !largePost 
            || !mq.matches 
            || !window.IS_HOME 
            || window.CONFIG_POSTS_PER_PAGE % 3 !== 0 
            || window.CUSTOM_FEED_LAYOUT !== "Dynamic grid"
        ) {
            return;
        }

        var xhr = new window.XMLHttpRequest();
        xhr.responseType = "document";

        xhr.addEventListener("load", function() {
            if (this.status >= 400) {
                return;
            }      
            
            var postElements = this.response.querySelectorAll(
                ".post-feed .post-card.post, .js-post-card"
            );            

            if (postElements.length === 0) {
                return;
            }

            var first = document.importNode(postElements[0], true);  
            first.classList.add("post-card-tmp");

            if (feedElement.querySelector("[id='" + first.id + "']")) {
                // The element exists already
                return;
            }
            
            feedElement.appendChild(first);

            if (postElements.length === 1) {
                loadMoreBtn.remove();
            }
        });

        xhr.open("GET", nextElement.href);
        xhr.send(null);                
    }

    fixCount();

    loadMoreBtn.addEventListener("click", onClick);
})(window, document);
